import React from 'react'
import styled from 'styled-components'
import { TRUST_BANNER } from '../content'
import { ink } from '../styled'

const Strip = styled.div`
  background: ${ink};
  color: #ffffff;
  text-align: center;
  padding: 9px 16px;
  font-size: clamp(10.5px, 2.6vw, 12.5px);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  @media (min-width: 481px) {
    letter-spacing: 0.09em;
  }
`

const TrustBanner = () => <Strip>{TRUST_BANNER}</Strip>

export default TrustBanner
